import axios from './axios'

export function getAlertList() {
  return axios({
    method: "get",
    url: '/api/v1/alerts/'
  })
}

export function getAlertDayList() {
  return axios({
    method: "get",
    url: '/api/v1/alerts/day/'
  })
}


